import { PLATFORM_TIME_ZONE, addDaysYmd, startOfDayInZone } from "./zone.js";

/** The instant of 00:00 in Sydney on a calendar day ("2026-09-01"), as an ISO string. Billing months are Sydney months. */
export function sydneyMidnightIso(ymd: string): string {
  return startOfDayInZone(ymd, PLATFORM_TIME_ZONE).toISOString();
}

/** The day after a calendar day, so an inclusive "to" date becomes an exclusive end. */
export function nextDay(ymd: string): string {
  return addDaysYmd(ymd, 1);
}
